import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { Notificacao } from '../../../shared/interfaces/notificacao';
import { NotificacaoService } from '../../../shared/services/notificacao.service';
import { BehaviorSubject } from 'rxjs';
import { NotificationDetailComponent } from './notification-detail/notification-detail.component';
import { JwtAuthService } from '../../services/auth/jwt-auth.service';
    import { combineLatest, Subscription } from 'rxjs';
    import { switchMap, filter } from 'rxjs/operators';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit {
  @Input() notificPanel;

  // notifications : Notificacao[] = [];
  //change notification to BehaviorSubject
  notifications = new BehaviorSubject<Notificacao[]>([]);
  notificationsLocal = new BehaviorSubject<Notificacao[]>([]);

  notificationsInfokaw = new BehaviorSubject<Notificacao[]>([]);

  constructor(    
    private dialog: MatDialog, 
    private router: Router,
    private jwtAuth: JwtAuthService,
    private notificacaoService: NotificacaoService) {}

  ngOnInit() {
    

    combineLatest([
      this.jwtAuth.itemRemoto$,
      this.jwtAuth.item$,
      this.jwtAuth.filial$
    ]).subscribe(([itemRemoto, item]) => {
      // console.log(`NOTIFICATIONSCOMPONENT - ITEMREMOTO: ${JSON.stringify(itemRemoto)}`);
      // console.log(`NOTIFICATIONSCOMPONENT - ITEM: ${JSON.stringify(item)}`);
      // console.log(`NOTIFICATIONSCOMPONENT - FILIAL: ${JSON.stringify(filial)}`);

      // Decide filialCodigo based on empresaRemota presence
      let filialCodigo: string | undefined;

      if (itemRemoto && itemRemoto.filialCodigo) {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO FROM ITEMREMOTO: ${itemRemoto.filialCodigo}`);
        filialCodigo = itemRemoto.filialCodigo.replace(/\D/g, '');
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO AFTER REPLACE: ${filialCodigo}`);
        this.loadNotifications(filialCodigo);
      } else if (item && item.filialCodigo) {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO FROM ITEM: ${item.filialCodigo}`);
        filialCodigo = item.filialCodigo.replace(/\D/g, '');
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO AFTER REPLACE: ${filialCodigo}`);
        this.loadNotifications(filialCodigo);
      } else {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO NOT FOUND`);
        filialCodigo = undefined;
        this.notificationsLocal.next([]);
        this.notificationsInfokaw.next([]);

      }

    });

    // Merge notificationsLocal and notificationsInfokaw into notifications
    combineLatest([
      this.notificationsLocal,
      this.notificationsInfokaw
    ]).subscribe(([local, infokaw]) => {
      const itens = [...(local ?? []), ...(infokaw ?? [])];
      // Exclude items with same uuid
      const itensUnicos = itens.filter((item, index, self) => index === self.findIndex((t) => (t.uuid === item.uuid)));
      this.notifications.next(itensUnicos);
      this.setTotalNotif(itensUnicos.length);
    });

    // Update total notifications when notifications change
    this.notifications.subscribe((notificacoes) => {
      this.setTotalNotif(notificacoes.length);
      console.log("TL notificacoes:", notificacoes.length);
    });

    // Close panel on navigation
    this.router.events.subscribe((routeChange) => {
      if (routeChange instanceof NavigationEnd) {
        this.notificPanel.close();
      }
    });
  }

  loadNotifications(filialCodigo: string) {
    this.notificacaoService.getNotificacoesValidas(filialCodigo).subscribe((notificacoes) => {
      this.notificationsLocal.next(notificacoes ?? []);
    });

    this.notificacaoService.getNotificacoesValidasInfokaw(filialCodigo).subscribe(notificacoes => {
      this.notificationsInfokaw.next((notificacoes??[]).map(notificacao => { return {...notificacao, fromInfokaw: true};}));
    });
  }

  private setTotalNotif(total = 0) {
    this.notificPanel.totalNotif = total;
  }

  closePanel() {
    this.notificPanel.close();
  }

  clearAll(e) {
    e.preventDefault();
    // this.notifications = [];
    this.notifications.next([]);
    this.setTotalNotif(0);
  }

  openPopUp(data: Notificacao) {
    const dialogRef: MatDialogRef<any> = this.dialog.open(NotificationDetailComponent, {
      width: '80%',
      disableClose: true,
      data: { title: '', payload: data }
    })
  }
  
  getIconByType(type: string) {
    switch (type) {
      case 'AVISO':
        return 'info';
      case 'COBRANCA':
        return 'attach_money';
      case 'VERSAO':
        return 'update';
      case 'PROMOCAO':
        return 'local_offer';
      case 'OUTRO':
        return 'notifications';
      default:
        return 'notifications';
    }
  }

  //get color by type
  getColorByType(type: string) {
    switch (type) {
      case 'AVISO':
        return 'accent';
      case 'COBRANCA':
        return 'warn';
      case 'VERSAO':
        return 'primary';
      case 'PROMOCAO':
        return 'accent';
      case 'OUTRO':
        return 'accent';
      default:
        return 'accent';
    }
  }


}
